import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Scene } from "@/components/landing/DemoPlayer";
import { SCENES } from "@/components/landing/demoScenes";

// Full-screen 16:9 sequence recorded into the presentation video: intro, real-screen scenes, extra stills, outro.
const STILLS = [
  { img: "details", step: "Fiche du poste", duration: 4.5, cap: "Sur chaque poste : mises à jour Windows et logiciels installées en un clic.", path: [[50, 50, 0], [50, 50, 4.5]], clicks: [], items: [] },
  { img: "health", step: "Santé", duration: 4.5, cap: "Disque presque plein, antivirus, pare-feu : les alertes arrivent avant la panne.", path: [[50, 50, 0], [50, 50, 4.5]], clicks: [], items: [] },
];
const STEPS = [{ kind: "intro", duration: 3.5 }, ...[...SCENES, ...STILLS].map((s) => ({ kind: "scene", s, duration: s.duration })), { kind: "outro", duration: 4.5 }];

const Brand = ({ big }) => (
  <div className="flex items-center gap-5">
    <img src="/logo-white.png?v=f5" alt="" className={big ? "h-28 w-28" : "h-16 w-16"} />
    <span className={`font-extrabold tracking-tight ${big ? "text-8xl" : "text-5xl"}`}>ScreenView</span>
  </div>
);

const Card = ({ children }) => (
  <motion.div className="absolute inset-0 grid place-items-center bg-[#0b1e3f] text-white" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
    <motion.div className="flex flex-col items-center text-center" initial={{ y: 24, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2, duration: 0.6 }}>{children}</motion.div>
  </motion.div>
);

export default function DemoVideo() {
  const [i, setI] = useState(-1);
  useEffect(() => {
    const go = setTimeout(() => { window.__demoStart = performance.now(); setI(0); }, 1500);
    return () => clearTimeout(go);
  }, []);
  useEffect(() => {
    if (i < 0) return undefined;
    if (i >= STEPS.length) { window.__demoDone = true; return undefined; }
    const t = setTimeout(() => setI(i + 1), STEPS[i].duration * 1000);
    return () => clearTimeout(t);
  }, [i]);
  const st = STEPS[Math.min(Math.max(i, 0), STEPS.length - 1)];
  return (
    <div className="fixed inset-0 bg-[#0b1e3f] overflow-hidden font-[Manrope,sans-serif]" data-testid="demo-video">
      <AnimatePresence mode="sync">
        {st.kind === "intro" && (
          <Card key="intro">
            <Brand big />
            <p className="mt-10 text-4xl text-white/80">Dépannez et surveillez tous vos PC, depuis votre navigateur.</p>
          </Card>
        )}
        {st.kind === "scene" && (
          <motion.div key={st.s.img + i} className="absolute inset-0" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }}>
            <div className="absolute inset-0"><Scene s={st.s} /></div>
            <div className="absolute left-10 right-10 bottom-10 rounded-2xl bg-[#0b1e3f]/90 border border-sky-400/40 px-8 py-5 flex items-center gap-6 shadow-2xl backdrop-blur">
              <img src="/logo-white.png?v=f5" alt="" className="h-12 w-12" />
              <div>
                <p className="text-sky-300 font-semibold text-xl">{st.s.step}</p>
                <p className="text-white text-3xl font-semibold">{st.s.cap}</p>
              </div>
            </div>
          </motion.div>
        )}
        {st.kind === "outro" && (
          <Card key="outro">
            <Brand big />
            <p className="mt-10 text-4xl text-white/80">Prise en main + supervision du parc, en français.</p>
            <p className="mt-8 rounded-full bg-sky-500 px-10 py-4 text-3xl font-bold">Essai gratuit 14 jours</p>
          </Card>
        )}
      </AnimatePresence>
    </div>
  );
}
